import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useGetHomeContractObligationAchieves } from "../../hooks/services/sCO/useOfObligacion.js";
import { __onGoToElementObligationAchives } from "../../common/SystemRedirections.js";
import { getGridLocalization, getPostponedDueDateText, isNullUndefined, isNullUndefinedOrEmpty } from "../../common/Helpers.js";
import AuthVerify from "../../components/Templates/Site/AuthVerify";
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import JqxInput from "jqwidgets-scripts/jqwidgets-react-tsx/jqxinput";
import { Card, Col, Row } from "react-bootstrap"
import { Checkbox } from "@fluentui/react";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import './style.css';
import { cloneDeep } from "lodash-es";
import Loading from "../../components/Templates/Site/Loading/index.js";
import { __GetClientRoleCode } from "../../common/CommonFuctions.js";
import { enum__AppElementType } from "../../common/Dictionaries.js";
import MainAppContext from "../../MainAppContext.js";

function HomeObligations() {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    
    const { token: currentAuth } = useSelector((state) => state.auth);
    
    const gridRef = useRef();

    const [filters, setFiltersActive] = useState({
        assetsiamresponsiblefor: false,
        assetsiamresponsibleforvalidating: false,
        viewonlycurrentcontracts: false,
        search: "",
    });

    const [listObligationAchieves, setlistObligationAchieves] = useState(null);
    const [listObligationAchievesFiltred, setlistObligationAchievesFiltred] = useState(null);
    useGetHomeContractObligationAchieves(listObligationAchieves, listObligationAchievesFiltred, setlistObligationAchieves, setlistObligationAchievesFiltred);    

    const getColumns = () => {
        const basicColumns = [
            { index: null, text: 'ELEMENT_ID',                                 dataField: 'elemenT_ID',                     uploadMasive: false, exportable: false, width: '0px',   editable: false, hidden: true },
            { index: 1,    text: t('data-lang-lbl-contractcode'),              dataField: 'codigO_CONTRATO',                uploadMasive: false, exportable: true,  width: '110px', editable: false, pinned: true,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-contractcode-1')}<br />${t('data-lang-lbl-contractcode-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    return `<div class="cursor-pointer h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefinedOrEmpty(value) ? value : t('no-data')}</div>`;
                }
            },
            { index: 2,    text: t('data-lang-lbl-areaname-short'),            dataField: 'area',                           uploadMasive: false, exportable: true,  width: '225px', editable: false, pinned: true,
                cellsrenderer: (row, column, value) => {
                    return `<div class="cursor-pointer h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefinedOrEmpty(value) && value !== '-' ? value : t('no-data')}</div>`;
                }
            },
            { index: 3,    text: t('data-lang-lbl-eecc'),                      dataField: 'emP_COLABORADORA',               uploadMasive: false, exportable: true,  width: '220px', editable: false, pinned: true,
                cellsrenderer: (row, column, value) => {
                    return `<div class="cursor-pointer h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefinedOrEmpty(value) && value !== '-' ? value : t('no-data')}</div>`;
                }
            },
            { index: 4,    text: t('data-lang-lbl-shortname'),                 dataField: 'obligacion',                     uploadMasive: false, exportable: true,  width: '300px', editable: false, pinned: true,
                cellsrenderer: (row, column, value) => {
                    const nemo = value.split(";")[0];
                    const nombre = value.split(";")[1];
                    return `<div class="cursor-pointer " style="margin-left: 8px; margin-top: 9px" title='${!isNullUndefinedOrEmpty(nemo) && nemo !== '-' ? nemo : t('no-data')}'>${!isNullUndefinedOrEmpty(value) && value !== '-' ? nombre : t('no-data')}</div>`;
                }
            },
            { index: 5,    text: t('data-lang-lbl-category'),                  dataField: 'categoria',                      uploadMasive: false, exportable: true,  width: '150px', editable: false, pinned: true,
                cellsrenderer: (row, column, value) => {
                    return `<div class="cursor-pointer h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefinedOrEmpty(value) && value !== '-' ? value : t('no-data')}</div>`;
                }
            },
            { index: 6,    text: t('data-lang-lbl-responsibleroleachieve'),    dataField: 'roL_RESPONSABLE',                uploadMasive: false, exportable: true,  width: '120px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-responsibleroleachieve-1')}<br />${t('data-lang-lbl-responsibleroleachieve-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    return `<div class="cursor-pointer h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefinedOrEmpty(value) && value !== '-' ? __GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, value) : t('no-data')}</div>`;
                }
            },
            { index: 7,    text: t('data-lang-lbl-responsiblerolevalidation'), dataField: 'roL_VALIDADOR',                  uploadMasive: false, exportable: true,  width: '120px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-responsiblerolevalidation-1')}<br />${t('data-lang-lbl-responsiblerolevalidation-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    return `<div class="cursor-pointer h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefinedOrEmpty(value) && value !== '-' ? __GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, value) : t('no-data')}</div>`;
                }
            },
            { index: 8,    text: t('data-lang-lbl-achievestatus'),             dataField: 'id',            uploadMasive: false, exportable: true,  width: '110px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-achievestatus-1')}<br />${t('data-lang-lbl-achievestatus-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    const item = listObligationAchieves.find(x => x.id === value);
                    const color = item.estadO_CUMPLIMIENTO_COLOR;
                    return `<div class="cursor-pointer h-100 w-100 text-center ${color}" style="margin-left: 0px">${`<div class="pt-2 h-100 w-100">${!isNullUndefinedOrEmpty(item.estadO_CUMPLIMIENTO) && item.estadO_CUMPLIMIENTO !== '-' ? item.estadO_CUMPLIMIENTO : t('no-data')}</div>`}</div>`;
                }
            },
            { index: 9,    text: t('data-lang-lbl-validationstatus'),          dataField: 'estadO_VALIDACION_CUMPLIMIENTO', uploadMasive: false, exportable: true,  width: '90px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-validationstatus-1')}<br />${t('data-lang-lbl-validationstatus-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    return `<div class="cursor-pointer h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefinedOrEmpty(value) && value !== '-' ? value : t('no-data')}</div>`;
                }
            },
            { index: 10,   text: t('data-lang-lbl-accumulatedpayments'),       dataField: 'vencimientoS_ACUMULADOS',        uploadMasive: false, exportable: true,  width: '110px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-accumulatedpayments-1')}<br />${t('data-lang-lbl-accumulatedpayments-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    return `<div class="cursor-pointer h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefinedOrEmpty(value) && value !== '-' ? value : t('no-data')}</div>`;
                }
            },
            { index: 11,   text: t('data-lang-lbl-lastduedate'),               dataField: 'fechA_ULTIMO_VENCIMIENTO',       uploadMasive: false, exportable: true,  width: '200px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-lastduedate-1')}<br />${t('data-lang-lbl-lastduedate-2')}</span></div>`; },
                // Si «Vencimiento se posterga» la corre al lunes: «sáb 28-Feb-26, vence lun 02-Mar-26».
                cellsrenderer: (row, column, value, defaulthtml, columnproperties, rowdata) => {
                    const text = getPostponedDueDateText(rowdata?.fechA_ULTIMO_VENCIMIENTO_DIA, rowdata?.fechA_ULTIMO_VENCIMIENTO_HABIL, t) ?? (!isNullUndefinedOrEmpty(value) ? value : t('no-data'));
                    return `<div class="cursor-pointer h-100 w-100" style="margin-left: 8px; padding-top: 9px">${text}</div>`;
                }
            },
            { index: 12,   text: t('data-lang-lbl-nextduedate'),               dataField: 'fechA_PROXIMO_VENCIMIENTO',      uploadMasive: false, exportable: true,  width: '200px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-nextduedate-1')}<br />${t('data-lang-lbl-nextduedate-2')}</span></div>`; },
                cellsrenderer: (row, column, value, defaulthtml, columnproperties, rowdata) => {
                    const text = getPostponedDueDateText(rowdata?.fechA_PROXIMO_VENCIMIENTO_DIA, rowdata?.fechA_PROXIMO_VENCIMIENTO_HABIL, t) ?? (!isNullUndefinedOrEmpty(value) && value !== '-' ? value : t('no-data'));
                    return `<div class="cursor-pointer h-100 w-100" style="margin-left: 8px; padding-top: 9px">${text}</div>`;
                }
            },
            { index: 13,   text: t('data-lang-lbl-compilanceindex'),           dataField: 'indicE_CUMPLIMIENTO',            uploadMasive: false, exportable: true,  width: '110px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-compilanceindex-1')}<br />${t('data-lang-lbl-compilanceindex-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    return `<div class="cursor-pointer h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefinedOrEmpty(value) && value !== '-' ? value : t('no-data')}</div>`;
                }
            },
        ]
        return basicColumns;
    };

    const getDataFields = () => {
        const basicDataFields = [
            { name: 'id',                             type: 'number' },
            { name: 'elemenT_ID',                     type: 'string' },
            { name: 'codigO_CONTRATO',                type: 'string' },
            { name: 'area',                           type: 'string' },
            { name: 'emP_COLABORADORA',               type: 'string' },
            { name: 'obligacion',                     type: 'string' },
            { name: 'obligacioN_ID',                  type: 'number' },
            
            { name: 'categoria',                      type: 'string' },
            { name: 'roL_RESPONSABLE',                type: 'string' },
            { name: 'roL_VALIDADOR',                  type: 'string' },
            { name: 'estadO_CUMPLIMIENTO',            type: 'string' },
            { name: 'estadO_VALIDACION_CUMPLIMIENTO', type: 'string' },
            { name: 'vencimientoS_ACUMULADOS',        type: 'string' },
            { name: 'fechA_ULTIMO_VENCIMIENTO',       type: 'string' },
            { name: 'fechA_PROXIMO_VENCIMIENTO',      type: 'string' },
            { name: 'fechA_ULTIMO_VENCIMIENTO_DIA',   type: 'string' },
            { name: 'fechA_ULTIMO_VENCIMIENTO_HABIL', type: 'string' },
            { name: 'fechA_PROXIMO_VENCIMIENTO_DIA',  type: 'string' },
            { name: 'fechA_PROXIMO_VENCIMIENTO_HABIL', type: 'string' },
            { name: 'indicE_CUMPLIMIENTO',            type: 'string' },
        ]
    
        return basicDataFields
    };

    const Obtener_Estado_Filas_Desplegadas = () => {
        const resultado = { status: "no-data", color: 'unset' };
        const vencidas = !isNullUndefinedOrEmpty(listObligationAchievesFiltred) ? listObligationAchievesFiltred.filter(x => x.estadO_CUMPLIMIENTO_ID === 4).length : 0;

        if (vencidas == 0) {
            const por_vencer = !isNullUndefinedOrEmpty(listObligationAchievesFiltred) ? listObligationAchievesFiltred.filter(x => x.estadO_CUMPLIMIENTO_ID === 3).length : 0;

            if (por_vencer == 0) {
                const cumplida = !isNullUndefinedOrEmpty(listObligationAchievesFiltred) ? listObligationAchievesFiltred.filter(x => x.estadO_CUMPLIMIENTO_ID === 1).length : 0;

                if (cumplida == 0) {
                    const exigible = !isNullUndefinedOrEmpty(listObligationAchievesFiltred) ? listObligationAchievesFiltred.filter(x => x.estadO_CUMPLIMIENTO_ID === 2).length : 0;

                    if (exigible == 0) {
                        resultado.status = "data-lang-lbl-inactive";
                        resultado.color = "whiteClassGlobal"
                    }
                    else {
                        resultado.status = "data-lang-lbl-enforceable";
                        resultado.color = "blueClassGlobal"
                    }
                }
                else {
                    resultado.status = "data-lang-lbl-accomplished";
                    resultado.color = "greenClassGlobal"
                }
            }
            else {
                resultado.status = "data-lang-lbl-toexpire";
                resultado.color = "yellowClassGlobal"
            }
        }
        else {
            resultado.status = "data-lang-lbl-overdue";
            resultado.color = "redClassGlobal"
        }

        return <div className={resultado.color} dangerouslySetInnerHTML={{__html: `<div class="${resultado.color}" >${t(resultado.status)}</div>`}}></div>
    }

    const onFilterIAmResponsible = (ev, checked, fieldName, configFieldName) => {
        const userName = currentAuth !== null && currentAuth.token !== null ? currentAuth.token.userName : "";
        let preFiltredData = cloneDeep(listObligationAchieves);

        filters[configFieldName] = checked;

        if (fieldName === 'roL_RESPONSABLE') {
            if (filters[configFieldName] === true) {
                preFiltredData = preFiltredData.filter(x => x[fieldName] === userName);
            }

            if (filters.assetsiamresponsibleforvalidating === true) {
                preFiltredData = preFiltredData.filter(x => x.roL_VALIDADOR === userName);
            }
        }
        else if (fieldName === 'roL_VALIDADOR') {
            if (filters[configFieldName] === true) {
                preFiltredData = preFiltredData.filter(x => x[fieldName] === userName);
            }

            if (filters.assetsiamresponsiblefor === true) {
                preFiltredData = preFiltredData.filter(x => x.roL_RESPONSABLE === userName);
            }
        }

        if (filters.viewonlycurrentcontracts === true) {
            preFiltredData = preFiltredData.filter(x => x.contratO_VIGENTE === true);
        }
        if (!isNullUndefinedOrEmpty(filters.assetsiamresponsibleforvalidating)) {
            preFiltredData = preFiltredData.filter(x => x.busquedA_CONCATENADA.indexOf(filters.search) !== -1);
        }

        setlistObligationAchievesFiltred(cloneDeep(preFiltredData))
        setFiltersActive(prevState => ({ ...prevState, [configFieldName]: filters[configFieldName] }));
    };

    const onFilterCurrentContracts = (ev, checked) => {
        let preFiltredData = cloneDeep(listObligationAchieves);
        filters.viewonlycurrentcontracts = checked;

        if (filters.viewonlycurrentcontracts === true) {
            preFiltredData = preFiltredData.filter(x => x.contratO_VIGENTE === true);
        }
        if (filters.assetsiamresponsiblefor === true) {
            const userName = currentAuth !== null && currentAuth.token !== null ? currentAuth.token.userName : "";
            preFiltredData = preFiltredData.filter(x => x.assetsiamresponsiblefor === userName);
        }
        if (filters.assetsiamresponsibleforvalidating === true) {
            const userName = currentAuth !== null && currentAuth.token !== null ? currentAuth.token.userName : "";
            preFiltredData = preFiltredData.filter(x => x.assetsiamresponsibleforvalidating === userName);
        }
        if (!isNullUndefinedOrEmpty(filters.assetsiamresponsibleforvalidating)) {
            preFiltredData = preFiltredData.filter(x => x.busquedA_CONCATENADA.indexOf(filters.search) !== -1);
        }

        setlistObligationAchievesFiltred(cloneDeep(preFiltredData))
        setFiltersActive(prevState => ({ ...prevState, viewonlycurrentcontracts: filters.viewonlycurrentcontracts }));
    };

    const onFilterText = (event) => {
        let preFiltredData = cloneDeep(listObligationAchieves);
        filters.search = event.currentTarget.value;

        if (!isNullUndefinedOrEmpty(filters.search)) {
            preFiltredData = preFiltredData.filter(x => x.busquedA_CONCATENADA.toLocaleLowerCase().indexOf(filters.search.toLocaleLowerCase()) !== -1)
        }
        if (filters.viewonlycurrentcontracts === true) {
            preFiltredData = preFiltredData.filter(x => x.contratO_VIGENTE === true);
        }
        if (filters.assetsiamresponsiblefor === true) {
            const userName = currentAuth !== null && currentAuth.token !== null ? currentAuth.token.userName : "";
            preFiltredData = preFiltredData.filter(x => x.roL_RESPONSABLE === userName);
        }
        if (filters.assetsiamresponsibleforvalidating === true) {
            const userName = currentAuth !== null && currentAuth.token !== null ? currentAuth.token.userName : "";
            preFiltredData = preFiltredData.filter(x => x.roL_VALIDADOR === userName);
        }

        setlistObligationAchievesFiltred(cloneDeep(preFiltredData))
        setFiltersActive(prevState => ({ ...prevState, search: filters.search }));
    };

    const handlerFilter = (event, fieldName) => {
        const filterinformation = event.args.filters.map(filterGroup => ({
            field: filterGroup.datafield,
            operator: filterGroup.operator,
            filters: filterGroup.filter.getfilters().map(filter => ({
                value: filter.value,
                condition: filter.condition,
                operator: filter.operator
            }))
        }));

        const actionFired = window.localStorage.getItem(`grid_filters_${fieldName}_ActionFired`);

        if (actionFired !== "1") {
            window.localStorage.setItem(`grid_filters_${fieldName}`, JSON.stringify(filterinformation));
        }
        window.localStorage.setItem(`grid_filters_${fieldName}_Fire`, 1);
    };

    const onHomeRowSelected = (event) => {
    const rowData = event.args.row.bounddata;  // todos los datos de la fila
    const id = rowData.obligacioN_ID;     

        __onGoToElementObligationAchives(event.args.row.bounddata.elemenT_ID, id);
    };

    return (
        <>
            <AuthVerify currentToken={currentAuth} />
            <Row className='pt-2'>
                <Col lg={12} xl={12} className='px-1'>
                    <Card>
                        <Card.Body className="p-0 m-0">
                            <Row>
                                <Col>
                                    <Row className="m-2">
                                        <Col className="my-auto">
                                            <Row>
                                                <Col>
                                                    <Row className="pb-2">
                                                        <Col>{`${0} ${t('data-lang-lbl-assetsiamresponsiblefor')}`}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col><Checkbox label={t('data-lang-lbl-viewassetsiamresponsiblefor')} checked={filters.assetsiamresponsiblefor} onChange={(ev, checked) => onFilterIAmResponsible(ev, checked, 'roL_RESPONSABLE', 'assetsiamresponsiblefor')} /></Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col className="my-auto">
                                            <Row>
                                                <Col>
                                                    <Row className="pb-2">
                                                        <Col>{`${0} ${t('data-lang-lbl-assetsiamresponsibleforvalidating')}`}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col><Checkbox label={t('data-lang-lbl-viewassetsiamresponsibleforvalidating')} checked={filters.assetsiamresponsibleforvalidating} onChange={(ev, checked) => onFilterIAmResponsible(ev, checked, 'roL_VALIDADOR', 'assetsiamresponsibleforvalidating')} /></Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col className="my-auto">
                                            <Row>
                                                <Col>
                                                    <Row className="pb-2">
                                                        <Col>{`${!isNullUndefined(listObligationAchievesFiltred) ? listObligationAchievesFiltred.length : '0'} ${t('data-lang-lbl-deployedobligations')}`}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className="d-flex"><div style={{backgroundClip: "red"}}>{Obtener_Estado_Filas_Desplegadas()}</div>&nbsp;&nbsp;{t('data-lang-lbl-statusofdeployedobligations')}</Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col className="my-auto">
                                            <Row>
                                                <Col>
                                                    <Row className="pb-2">
                                                        <Col><Checkbox label={t('data-lang-lbl-viewonlycurrentcontracts')} checked={filters.viewonlycurrentcontracts} onChange={onFilterCurrentContracts} /></Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className="d-flex">{t('data-lang-btn-search')}&nbsp;&nbsp;
                                                            <JqxInput height={25} width={"100%"} maxLength={60} value={filters.search} onChange={onFilterText} />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                {
                                    !isNullUndefined(listObligationAchievesFiltred) && !isNullUndefined(listObligationAchieves) && listObligationAchievesFiltred.length > 0 &&
                                    <JqxGrid
                                        ref={gridRef}
                                        altrows={true}
                                        enabletooltips={true}
                                        width={'100%'}
                                        theme={'light'} 
                                        height={'600px'}
                                        editable={false}
                                        sortable={true}
                                        //filterable={true}
                                        //showfilterrow={true} 
                                        filterable={false}
                                        showfilterrow={false} 
                                        localization={getGridLocalization(t)}
                                        source={ new jqx.dataAdapter({
                                            localData: listObligationAchievesFiltred,
                                            dataType: 'array',
                                            dataFields: getDataFields(),
                                            id: 'id'
                                        })}
                                        columns={getColumns()}
                                        onRowclick={onHomeRowSelected}
                                        //onFilter={(e) => handlerFilter(e, 'HomeObligationAchieves')}
                                    />
                                }
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
}

export default HomeObligations;